document.addEventListener('DOMContentLoaded', () => {
  const mobileButton = document.querySelector('[data-mobile-toggle]');
  const mobileDrawer = document.getElementById('mobile-menu');
  const overlay = document.querySelector('[data-mobile-overlay]');
  const closeButton = document.querySelector('[data-mobile-close]');
  const desktop = document.querySelector('.desktop-nav');
  const roots = [desktop,mobileDrawer].filter(Boolean);
  function closeBranch(item){
    const panel=item.querySelector(':scope > .nav-submenu');
    if(panel)panel.hidden=true;
    item.classList.remove('open');
    item.querySelector(':scope > .nav-link-row > [data-submenu-toggle]')?.setAttribute('aria-expanded','false');
    item.querySelectorAll('.nav-item.open').forEach(n=>n.classList.remove('open'));
    item.querySelectorAll('.nav-submenu').forEach(n=>n.hidden=true);
    item.querySelectorAll('[data-submenu-toggle]').forEach(n=>n.setAttribute('aria-expanded','false'));
  }
  function reset(root){root.querySelectorAll('.nav-root > .nav-item').forEach(closeBranch);}
  roots.forEach(root=>{
    reset(root);
    root.querySelectorAll('[data-submenu-toggle]').forEach(button=>button.addEventListener('click',e=>{
      e.preventDefault();
      const item=button.closest('.nav-item');
      const panel=item?.querySelector(':scope > .nav-submenu');
      if(!panel)return;
      const opening=panel.hidden;
      const siblings=item.parentElement?.querySelectorAll(':scope > .nav-item');
      siblings?.forEach(other=>{if(other!==item)closeBranch(other)});
      if(opening){panel.hidden=false;item.classList.add('open')}else{closeBranch(item)}
      button.setAttribute('aria-expanded',String(opening));
    }));
  });
  function dismiss(){
    if(mobileDrawer)mobileDrawer.hidden=true;
    if(overlay)overlay.hidden=true;
    mobileButton?.setAttribute('aria-expanded','false');
    document.body.classList.remove('mobile-menu-open');
    roots.forEach(reset);
  }
  mobileButton?.addEventListener('click',()=>{
    if(!mobileDrawer)return;
    if(!mobileDrawer.hidden){dismiss();return}
    reset(mobileDrawer);mobileDrawer.hidden=false;
    if(overlay)overlay.hidden=false;
    mobileButton.setAttribute('aria-expanded','true');
    document.body.classList.add('mobile-menu-open');
    closeButton?.focus({preventScroll:true});
  });
  closeButton?.addEventListener('click',()=>{dismiss();mobileButton?.focus()});
  overlay?.addEventListener('click',dismiss);
  document.addEventListener('keydown',e=>{if(e.key==='Escape'){if(mobileDrawer&&!mobileDrawer.hidden){dismiss();mobileButton?.focus()}else if(desktop)reset(desktop)}});
  window.addEventListener('resize',()=>{if(window.innerWidth>1050&&mobileDrawer&&!mobileDrawer.hidden)dismiss()});
  document.addEventListener('click',e=>{if(desktop&&!desktop.contains(e.target))reset(desktop)});
document.querySelectorAll('[data-slider]').forEach(slider=>{const slides=[...slider.querySelectorAll('[data-slide]')];if(slides.length<2)return;let current=0;const show=i=>{current=(i+slides.length)%slides.length;slides.forEach((s,n)=>{s.classList.toggle('active',n===current);s.setAttribute('aria-hidden',String(n!==current));});};slider.querySelector('[data-prev]')?.addEventListener('click',()=>show(current-1));slider.querySelector('[data-next]')?.addEventListener('click',()=>show(current+1));if(!window.matchMedia('(prefers-reduced-motion: reduce)').matches){let timer=setInterval(()=>show(current+1),Number(slider.dataset.interval)||6000);slider.addEventListener('mouseenter',()=>clearInterval(timer));slider.addEventListener('mouseleave',()=>{clearInterval(timer);timer=setInterval(()=>show(current+1),Number(slider.dataset.interval)||6000);});}});
});

/* Fit the main desktop dropdown into the actual viewport beneath the nav bar. */
(function(){
 const desktop=document.querySelector('.site-header .desktop-nav');
 if(!desktop)return;
 const fit=()=>{
  if(window.innerWidth<=1050)return;
  desktop.querySelectorAll('.nav-root > .nav-item > .nav-submenu').forEach(panel=>{
   const top=panel.getBoundingClientRect().top;
   panel.style.setProperty('max-height',Math.max(150,Math.floor(window.innerHeight-top-16))+'px','important');
  });
 };
 desktop.addEventListener('click',e=>{if(e.target.closest('[data-submenu-toggle]'))requestAnimationFrame(fit)});
 window.addEventListener('resize',fit);
 fit();
})();

/* ILW: Move the selected accordion heading to the top of its scrollable parent.
   Keeps long lists reachable and gives later groups the same viewing room. */
(function () {
 const desktop=document.querySelector('.site-header .desktop-nav');
 if(!desktop)return;
 desktop.addEventListener('click',function(event){
  const toggle=event.target.closest('[data-submenu-toggle]');
  if(!toggle || window.innerWidth<=1050)return;
  const item=toggle.closest('.nav-item');
  if(!item)return;
  requestAnimationFrame(()=>requestAnimationFrame(()=>{
   if(!item.classList.contains('open'))return;
   const parent=item.parentElement;
   if(!parent || !parent.classList.contains('nav-submenu'))return;
   const parentBox=parent.getBoundingClientRect();
   const row=item.querySelector(':scope > .nav-link-row');
   if(!row)return;
   const rowBox=row.getBoundingClientRect();
   parent.scrollTop += rowBox.top-parentBox.top;
   /* If the containing accordion is below the outer viewport, bring it up. */
   const root=item.closest('.nav-root > .nav-item > .nav-submenu');
   if(root && root!==parent){
    const rootBox=root.getBoundingClientRect();
    const pBox=parent.getBoundingClientRect();
    if(pBox.top>rootBox.top+32)root.scrollTop+=pBox.top-rootBox.top;
   }
  }));
 });
})();
